// app/javascript/controllers/select_all_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox'];

  toggleAll(event) {
    const checked = event.target.checked;
    this.checkboxTargets.forEach((cb) => {
      cb.disabled = false;
      cb.checked = checked;
      cb.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
}
